// extracted by mini-css-extract-plugin
export default {"detailContainer":"noteDetails_detailContainer__NAuTp","noteDetails":"noteDetails_noteDetails__Tw7P6","cross":"noteDetails_cross__4BNZF"};